import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "./AuthContext";

export default function PublicRoute({ children }) {
  const { user } = useContext(AuthContext);

  // Si hay usuario logueado, redirige según rol
  if (user) {
    if (user.rol === "admin") return <Navigate to="/admin" replace />;
    if (user.rol === "empleado") return <Navigate to="/empleados" replace />;
    return <Navigate to="/" replace />; // fallback
  }

  // Si no hay usuario, deja acceder a la ruta
  return children;
}
